import PortalOverride from '@Components/admin/portal-override';
import { AppContext } from '@Context/common/general/context';
import { Button, Dialog, DialogActions, Grid, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';
import Storage from '@Storage';
import { useContext, useEffect, useState } from 'react';

let reloadTimeout: any = null;

export default () => {
    const { state } = useContext(AppContext);

    const [url, setUrl] = useState<string | null>(null);
    const [selection, setSelection] = useState<number>(0);
    const [showOverride, setShowOverride] = useState<boolean>(false);

    const loadUrl = (url: string) => {
      window.location.href = url;

      // reloadTimeout = setTimeout(() => {
      // }, 5000);
      //   UnityBridge.dispatchWebEvent({
      //     type: UnityBridge.OutgoingWebEvents.OverrideGameUrl,
      //     payload: {
      //       url: url
      //     }
      //   });
      //   reloadTimeout = setTimeout(() => {
      //     window.location.reload();
      //   }, 5000);
    }

    const refreshCache = () => {
      const devStoredUrl = Storage.get({ key: "devStoredUrl" });
      if(devStoredUrl) {
          setUrl(devStoredUrl);
      }
    }

    const reload = () => {
      window.location.reload();
    }
  
    useEffect(()=>{
      refreshCache();
      return () => {
        clearTimeout(reloadTimeout);
      }
    }, []);

    return url !== null ? <Dialog id={"DEV_SERVICE"}
            open={true}
        >
        <DialogActions>
            <Grid container spacing={2}>
            <Grid item xs={12}>
              {showOverride ?
                <PortalOverride/>
              :
              <Stack spacing={1.5}>
                <Typography gutterBottom variant='h6'>{`DEV SERVICE`}</Typography>
                <Typography>{`Current: ${window.location.href}`}</Typography>
                <Typography>Load from cached environment?</Typography>
                <Select
                  size='small' 
                  variant='outlined'
                  fullWidth
                  value={selection}
                  onChange={(e: SelectChangeEvent<number>) => {
                      setSelection(e.target.value as number);
                  }}
                >
                  {[url].map((url, i)=> <MenuItem key={i} value={i}>{url}</MenuItem>)}
                </Select>
                <Button variant='contained' size='small' color='primary' onClick={()=>{loadUrl([url][selection])}}>Load URL</Button>
                <Button variant='contained' size='small' color='inherit' onClick={()=>{setShowOverride(true)}}>{`Edit URLS`}</Button>
                <Button variant='contained' size='small' color='inherit' onClick={()=>{ Storage.remove({key: 'devStoredUrl'}); reload() }}>{`Reset`}</Button>
              </Stack>
              }
            </Grid>
          </Grid>
        </DialogActions>
    </Dialog> : null;
}